import { PowerOfAttorneyFlags, PowerOfAttorneyModel } from "api";
import { dateToView } from "helpers/date";

export function isPaperPowerOfAttorney(powerOfAttorney: { intFlags: number }) {
    return (powerOfAttorney.intFlags & PowerOfAttorneyFlags.IsPaper) === PowerOfAttorneyFlags.IsPaper;
}

export function isDefaultPowerOfAttorney(powerOfAttorney: { intFlags: number }) {
    return (powerOfAttorney.intFlags & PowerOfAttorneyFlags.IsDefault) === PowerOfAttorneyFlags.IsDefault;
}

export function powerOfAttorneyLabel(powerOfAttorney: PowerOfAttorneyModel) {
    const type = isPaperPowerOfAttorney(powerOfAttorney) ? "Бумажная" : "МЧД";
    const issueDate = powerOfAttorney.issueDate ? ` от ${dateToView(powerOfAttorney.issueDate)}` : "";
    return `${type}: ${powerOfAttorney.externalId || "без номера"}${issueDate}`;
}

const isStringArray = (value: unknown): value is string[] =>
    Array.isArray(value) && value.every((message: unknown) => typeof message === "string");

export function extractErrorMessage(error: unknown, defaultMessage = "Произошла ошибка"): string {
    if (typeof error === "string") {
        try {
            const decoded: unknown = JSON.parse(error);
            if (typeof decoded === "string") {
                return decoded;
            }
            if (decoded !== null && typeof decoded === "object") {
                return extractErrorMessage(decoded, defaultMessage);
            }
        } catch {
            return error;
        }
        return error;
    }
    if (!error || typeof error !== "object") {
        return defaultMessage;
    }
    if ("name" in error && error.name === "HttpError" && "body" in error) {
        return extractErrorMessage(error.body, defaultMessage);
    }
    if (error instanceof Error) {
        return error.message || defaultMessage;
    }
    if (!Array.isArray(error)) {
        const messages: unknown[] = Object.values(error);
        if (messages.length && messages.every(isStringArray)) {
            return messages.flat()[0] ?? defaultMessage;
        }
    }
    return defaultMessage;
}
